module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG5a3b99fc6f8a3105bd975a37071449bc.5a3b99fc.png";